export enum DiaPagamento {
  DIA_5 = '5',
  DIA_10 = '10',
  DIA_15 = '15',
  DIA_20 = '20',
  DIA_25 = '25',
}
